import MessageArgs, { defaultMessageArgs } from './message-args'

export default interface CallbackArgs extends MessageArgs {
  errorCode: number
  errorMessage: string
  [key: string]: any
}

export function defaultCallbackArgs(): CallbackArgs {
  return {
    ...defaultMessageArgs(),
    errorCode: 0,
    errorMessage: '',
  }
}
